import React from 'react'

import { useAuthState } from 'react-firebase-hooks/auth'
import { Navigate, useLocation } from 'react-router-dom'

import { auth } from '@/firebase'

const AuthedRoute = ({ component }: { component: React.ReactElement }) => {
  const [user] = useAuthState(auth)
  const location = useLocation()
  const shouldBypassAuth =
    !import.meta.env.PROD &&
    (import.meta.env.MODE === 'e2e' ||
      import.meta.env.VITE_E2E_AUTH_BYPASS === 'true' ||
      new URLSearchParams(window.location.search).has('e2e-auth-bypass'))

  if (shouldBypassAuth) {
    return component
  }

  if (!user) {
    return <Navigate to="/sign-in" replace />
  }

  if (!user.emailVerified && location.pathname !== '/verify-email') {
    return <Navigate to="/verify-email" replace />
  }

  return component
}

export default AuthedRoute
